import { UPLOAD_CONFIG } from '@/config/uploadConfig';

/**
 * Parse Retry-After header value
 * @param {string|number|null|undefined} retryAfter - Header value (seconds or HTTP date)
 * @returns {number} Delay in milliseconds
 */
export function parseRetryAfter(retryAfter) {
  if (!retryAfter || retryAfter === null) {
    return UPLOAD_CONFIG.DEFAULT_RETRY_AFTER_MS;
  }

  const seconds = parseInt(retryAfter, 10);
  if (!isNaN(seconds)) {
    const delayMs = seconds * 1000;

    return Math.min(delayMs, UPLOAD_CONFIG.MAX_RETRY_AFTER_MS);
  }

  const retryDate = new Date(retryAfter);
  if (!isNaN(retryDate.getTime())) {
    const delayMs = Math.max(0, retryDate.getTime() - Date.now());

    return Math.min(delayMs, UPLOAD_CONFIG.MAX_RETRY_AFTER_MS);
  }

  return UPLOAD_CONFIG.DEFAULT_RETRY_AFTER_MS;
}

/**
 * Custom retry logic for Uppy AwsS3 plugin
 * Handles 429 errors with Retry-After header
 */
export function shouldRetryRequest(error, retryAttempt, retryDelays) {
  const is429 = error?.source?.status === 429 ||
    error?.message?.includes('429') ||
    error?.message?.toLowerCase().includes('too many requests');

  if (is429) {
    const retryAfter =
      error?.source?.retryAfter ??
      error?.source?.headers?.['retry-after'] ??
      error?.source?.headers?.['Retry-After'];

    const delay = parseRetryAfter(retryAfter);

    return {
      shouldRetry: true,
      delay: delay,
    };
  }

  if (retryAttempt < retryDelays.length) {
    return {
      shouldRetry: true,
      delay: retryDelays[retryAttempt],
    };
  }

  return {
    shouldRetry: false,
    delay: 0,
  };
}
